module.exports = __webpack_public_path__ + "img/qr-code-placeholder.b7e45214.svg";